
<div class="main-container">
    <div class="dialog-body">
        <div class="dialog-body-content">
            <div class="dialog-align">
                <img alt="success" src="../../../assets/Alert_box/success_tick.svg">
            </div>
            <div>
                <h2 class="message"> {{data.successMessage}}</h2>
                <div style="margin-top: 8px;" *ngIf="data.ticketIds?.length">
                    <ul class="ticket-list">
                        <li *ngFor="let ticketId of data.ticketIds">{{ticketId}}</li>
                    </ul>
                </div>
                <p *ngIf="data.isVideo" style="font-size: 15px;">Please wait sometime for the video to get reflected in the table.</p>
                <p *ngIf="data.isAd" style="font-size: 15px;">Please wait sometime for the video Ad to get reflected in the table.</p>
                <p *ngIf="data.isClip" style="font-size: 15px"> You can view the generated clip in the clips 
                    table on the corresponding channel details page.Please wait sometime for the clip to get reflected in the table.</p>
            </div>
        </div>
        <img alt="close" (keypress)="dialogRef.close()" class="close-dialog" (click)="dialogRef.close()" src="../../../assets/Alert_box/close_icon.svg">
    </div>
    
</div>